import { render } from "./ItemGroupButton.vue?vue&type=template&id=54db83b0&scoped=true"
import script from "./ItemGroupButton.vue?vue&type=script&lang=js"
export * from "./ItemGroupButton.vue?vue&type=script&lang=js"

import "./ItemGroupButton.vue?vue&type=style&index=0&id=54db83b0&scoped=true&lang=css"

import exportComponent from "/Users/anwarfuadi/Documents/nyp/gigihpack.com/fe/gigihpack/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54db83b0"]])

export default __exports__